import { CheckCircle, Cancel } from '@mui/icons-material/';
import PropTypes from 'prop-types';

export default function CheckIcon({ checked, ...rest }) {
  if (checked) return <CheckCircle {...rest} style={{ color: '#2ECC71' }} />;
  return <Cancel {...rest} style={{ color: '#EE7B57' }} />;
}

CheckIcon.propTypes = {
  checked: PropTypes.bool,
};

CheckIcon.defaultProps = {
  checked: false,
};
